import {
  IUpdateServiceDefinitionResult,
  addToServiceDefinition,
  updateServiceDefinition,
} from '@esri/arcgis-rest-feature-service';
import { ArcGISIdentityManager } from '@esri/arcgis-rest-request';

export async function updateField({
  layerUrl,
  accountManager,
  field,
  mode,
}: {
  layerUrl: string;
  accountManager: ArcGISIdentityManager;
  field: IFieldWithDescription;
  mode: 'create' | 'edit';
}): Promise<IUpdateServiceDefinitionResult> {
  const updateFunction =
    mode === 'create' ? addToServiceDefinition : updateServiceDefinition;

  return updateFunction(layerUrl, {
    authentication: accountManager,

    params: {
      [mode === 'create' ? 'addToDefinition' : 'updateDefinition']: {
        fields: [field],
      },
    },
  });
}
